export function toFormData(fields: Record<string, unknown>) {
	const formData = new FormData();
	const record = fields as Record<string, string | Blob>;
	for (const key in record) {
		formData.append(key, record[key]);
	}
	return formData;
}
